import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

import { API } from "./config/api";
const WellContext = createContext(null);
export function shortName(fullPath) {
  if (!fullPath) return "";
  return fullPath.split("/").pop();
}

export function WellProvider({ children }) {
  const [wells, setWells] = useState([]);
  const [selectedWell, setSelectedWell] = useState(null);
  const [wellsLoading, setWellsLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/wells`)
      .then(r => {
        const list = r.data.wells || [];
        const sorted = [...list].sort((a, b) => {
          const na = shortName(a);
          const nb = shortName(b);
          const aF = (na === "WELL_1" || na.endsWith("_1")) ? 0 : 1;
          const bF = (nb === "WELL_1" || nb.endsWith("_1")) ? 0 : 1;
          if (aF !== bF) return aF - bF;
          return na.localeCompare(nb);
        });
        setWells(sorted);
        setSelectedWell(sorted[0] || null);
        setWellsLoading(false);
      })
      .catch(() => setWellsLoading(false));
  }, []);

  function apiUrl(path) {
    if (!selectedWell) return `${API}${path}`;
    const sep = path.includes("?") ? "&" : "?";
    return `${API}${path}${sep}well=${encodeURIComponent(selectedWell)}`;
  }

  return (
    <WellContext.Provider value={{ wells, selectedWell, setSelectedWell, shortName, apiUrl, wellsLoading }}>
      {children}
    </WellContext.Provider>
  );
}

export function useWell() { return useContext(WellContext); }